import React, { Dispatch, ReactNode, SetStateAction, useState, createContext } from 'react'
import Category from '../models/Category';
import Item from '../models/Item';

type Props = {
    children: ReactNode
}

interface MainContextType {
    categories: Category[];
    setCategories: Dispatch<SetStateAction<Category[]>>;
    token: string | null;
    setToken: Dispatch<SetStateAction<string | null>>;
    basketItems: Map<Item, number>;
    setBasketItems: Dispatch<SetStateAction<Map<Item, number>>>;
    openBasket: boolean;
    setOpenBasket: Dispatch<SetStateAction<boolean>>;
    updateBasket: (item: Item, quantity: number) => void;
    openAddItemModal: Item | null;
    setOpenAddItemModal: Dispatch<SetStateAction<Item | null>>;
    addItemToBasket: (item: Item) => void;
}
export const MainContext = createContext<MainContextType>({} as MainContextType);

const MainContextProvider = (props: Props) => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [token, setToken] = useState<string | null>(null);
    const [basketItems, setBasketItems] = useState<Map<Item, number>>(new Map<Item, number>());
    const [openBasket, setOpenBasket] = useState(false);
    const [openAddItemModal, setOpenAddItemModal] = useState<Item | null>(null);
    const updateBasket = (item: Item, quantity: number) => {
        setBasketItems(prev => {
            const newMap = new Map(prev);
            const existingEntry = Array.from(newMap.keys()).find(i => i.id === item.id);
            if (existingEntry) {

                if (quantity > 0) {
                    newMap.set(existingEntry, quantity);
                } else {
                    newMap.delete(existingEntry);
                }
            } else if (quantity > 0) {
                newMap.set(item, quantity);
            }
            return newMap;
        });
    };

    const addItemToBasket = (item: Item) => {
        setBasketItems(prev => {
            const newMap = new Map(prev);
            const existingEntry = Array.from(newMap.keys()).find(i => i.id === item.id);
            if (existingEntry) {
                const currentQuantity = newMap.get(existingEntry) ?? 0;
                newMap.set(existingEntry, currentQuantity + 1);
            } else {
                newMap.set(item, 1);
            }
            return newMap;
        });
    };

    const contextValues = {
        categories,
        setCategories: setCategories,
        token,
        setToken: setToken,
        basketItems,
        setBasketItems: setBasketItems,
        openBasket,
        setOpenBasket: setOpenBasket,
        updateBasket: updateBasket,
        openAddItemModal,
        setOpenAddItemModal: setOpenAddItemModal,
        addItemToBasket: addItemToBasket,
    }

    return (
        <MainContext.Provider value={contextValues}>
            {props.children}
        </MainContext.Provider>
    );
}

export default MainContextProvider;